export const CHARTCOLORS = {
    COLOR1: "#8A66D9",
    COLOR2: "#5E9ABF",
    COLOR3: "#4EB4BF",
    COLOR4: "#36BFA6",
    COLOR5: "#111111",
    BLACK: "#000",
    WHITE: "#fff",
}
